import { SignIn } from "@clerk/clerk-react";

export default function SignInPage() {
  return (
    <div className="flex items-center justify-center w-full h-dvh">
      <SignIn path="/sign-in" forceRedirectUrl="/org-selector" />
    </div>
  );
}